import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { DoubleChargeDetailDto } from 'src/generated/services/TFinancialApi';
import { tFinancialService } from 'src/infra/services/tFinancialService';
import { cacheKeysUtil } from 'src/utils/cacheKeysUtil';

export const useDoubleChargeDetails = (deviationId: string): UseQueryResult<DoubleChargeDetailDto> =>
  useQuery(
    cacheKeysUtil.doubleChargeDetails(deviationId),
    async (): Promise<DoubleChargeDetailDto> => {
      const response = await tFinancialService.api.getDoubleChargeDetail(deviationId);
      return response.data?.data;
    },
    {
      enabled: !!deviationId,
      staleTime: 5 * 60 * 1000,
    }
  );
